import { render, staticRenderFns } from "./ViewVideos.vue?vue&type=template&id=44029b25&scoped=true"
import script from "./ViewVideos.vue?vue&type=script&lang=js"
export * from "./ViewVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44029b25",
  null
  
)

export default component.exports